<div class="order-vouchers">
  <div class="voucher-input">
    <ui-form-text [formControl]="voucherResponseControl" [data]="voucherInputConfig()"></ui-form-text>
    <ui-button (click)="applyVoucher()" buttonStyle="text" [loading]="loading()" [disabled]="loading()">
      @if (!loading()) {
        Einlösen
      }
    </ui-button>
  </div>
  <div class="voucher-list">
    @for (voucher of data(); track voucher.code) {
      <ui-order-voucher-item [voucher]="voucher" [deleting]="deleting()" (deleteVoucher)="deleteVoucher($event)"></ui-order-voucher-item>
    }
  </div>
</div>
